import { Box, Typography } from "@mui/material";

export default function Hero() {
  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        // Dark overlay on the hero image to make white text readable
        backgroundImage:
          "linear-gradient(rgba(18, 18, 18, 0.7), rgba(18, 18, 18, 0.9)), url('/hero-bg.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 1200,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h2"
          color="primary"
          sx={{ fontSize: { xs: "2.5rem", md: "4rem" }, mb: 2 }}
        >
          EDEB-Estrichbau
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontSize: { xs: "1.2rem", md: "1.5rem" }, color: "text.primary", mb: 4 }}
        >
          Ihr zuverlässiger Partner für Estrich- und Abbrucharbeiten mit über
          30 Jahren Erfahrung
        </Typography>

        <Typography sx={{ mt: 2, color: "text.secondary", maxWidth: 800, mx: "auto", fontSize: "1.1rem" }}>
          Unsere Kunden schätzen unsere Fachkenntnisse, Termintreue, hohe
          Qualität, unser faires Preis-Leistungs-Verhältnis sowie unsere
          Flexibilität.
          <br />
          <br />
          Das Handwerk ist unsere Leidenschaft – sie ist der Grund für unsere
          Qualität und langjährige Kundenzufriedenheit.
        </Typography>
      </Box>
    </Box>
  );
}
